import { useState, useEffect } from 'react';
import { MatchTurbinePathParams } from '../../shared/models/matchTurbinePathParams';

const useTurbinePath = (params: MatchTurbinePathParams): [string, string, string, string] => {
  const [site, setSite] = useState('');
  const [inspection, setInspection] = useState('');
  const [turbine, setTurbine] = useState('');

  useEffect(() => {
    const { site, inspection, turbine } = params;
    setSite(site);
    setInspection(inspection);
    setTurbine(turbine);
  }, [params]);

  return [site, inspection, turbine, site.length > 0 ? `${site}/${inspection}/${turbine}` : ''];
};

export default useTurbinePath;
